import { render, staticRenderFns } from "./TagsEditor.vue?vue&type=template&id=102d6172&scoped=true&"
import script from "./TagsEditor.vue?vue&type=script&lang=js&"
export * from "./TagsEditor.vue?vue&type=script&lang=js&"
import style0 from "./TagsEditor.vue?vue&type=style&index=0&id=102d6172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102d6172",
  null
  
)

export default component.exports